import { useSyncExternalStore } from 'react'
import { Database, getDb, subscribe } from '../services/store'

/** Suscripción al store de datos. Al conectar Supabase se sustituye por
 *  react-query / realtime sin tocar los componentes que lo consumen. */
export function useDatabase(): Database {
  return useSyncExternalStore(subscribe, getDb, getDb)
}
